import module from 'app/module.js'
import template from './template.html'

const scorePassword = (pass) => {
  let score = 0
  if (!pass) return score

  let letters = {}
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1
    score += 5.0 / letters[pass[i]]
  }

  let variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  }

  let variationCount = Object.values(variations)
    .reduce((variations, check) => variations + (check ? 1 : 0), 0)

  score += (variationCount - 1) * 10

  return Math.floor(score < 100 ? score : 100)
}

export class ReestablecerModificacionComponent {

  data = {
    usuario: null,
    usuario_id: null,
    activo: null,
    contrasena: null,
    confirmacion: null,
    passSafe: null,
    terminos: null,
  }
  promise = null
  token = null
  actualizoContrasena = null

  validaciones = {
    strength: (value) => this.seguridadPassword(value),
  }

  passwordConfirmacion = {
    passmatch: (value) => this.confirmarPassword(value),
  }

  constructor (RestablecerToken, UsuarioReestablecer) {
    this.RestablecerToken = RestablecerToken
    this.UsuarioReestablecer = UsuarioReestablecer
  }

  $onInit () {
    this.promise = this.RestablecerToken.get(this.token)
      .then(({data}) => (this.data = data))
  }

  seguridadPassword (value) {
    let score = scorePassword(value)
    this.password_strength = score
    this.meter_color = score < 25 ? '' : score < 50 ? 'weak' : score < 75 ? 'good' : 'strong'
    return score >= 50
  }

  confirmarPassword (value) {
    return this.data.contrasena === value
  }

  restablecer(){

    if (this.restableciendo) return

    this.restableciendo = true
    this.error = null
    this.UsuarioReestablecer.put(this.data, this.token)
      .then(({data}) => (this.actualizoContrasena = true))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.restableciendo = false))
  }
}

module.component('restablecerModificacion', {
  controller: ReestablecerModificacionComponent,
  template,
  bindings: {
    token: '<',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/restablecer/modificacion/component.js